import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import avtar5 from '../../assets/images/user/avatar-5.jpg'
import { getData, putData,imgUrl } from '../Services/api';
import { toast } from 'react-toastify';

const View = () => {
    const { id } = useParams();
    const [complaint, setComplaint] = useState(null);
    const [replyMessage, setReplyMessage] = useState('');
    const [replyImage, setReplyImage] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchComplaintDetails = async () => {
        try {
            const res = await getData(`/complaints/details/${id}`);
            if (res.success) {
                setComplaint(res.data);
            }
        } catch (error) {
            console.log("error fetch complaints details", error);
        }
    }

    useEffect(() => {
        fetchComplaintDetails();
    }, [id]);


    const handleSendReply = async () => {
  if (!replyMessage.trim() && !replyImage) {
    toast.error("Reply or image must be provided.");
    return;
  }
  setLoading(true);
  try {
    const formData = new FormData();
    formData.append("reply", replyMessage);
    formData.append("type", complaint.type);
    if (replyImage) formData.append("admin_reply_image", replyImage); // backend field name

    const res = await fetch(`${imgUrl}/api/v1/complaints/update/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: formData,
    });

    const data = await res.json();
    if (data.success) {
      toast.success("Reply sent successfully");
      setReplyMessage('');
      setReplyImage(null);
      fetchComplaintDetails();
    } else {
      toast.error(data.message || "Failed to send reply");
    }
  } catch (error) {
    console.error("Error sending reply", error);
    toast.error("Error sending reply");
  } finally {
    setLoading(false);
  }
};


    // const handleSendReply = async () => {
    //     if (!replyMessage.trim()) {
    //         toast.error("Reply cannot be empty.");
    //         return;
    //     }
    //     setLoading(true);
    //     try {
    //         const res = await putData(`/complaints/update/${id}`, {
    //             reply: replyMessage,
    //             type:complaint.type
    //         });

    //         if (res.success) {
    //             toast.success("Reply sent successfully");
    //             setReplyMessage('');
    //             fetchComplaintDetails(); // refresh complaint details
    //         } else {
    //             toast.error(res.message || "Failed to send reply");
    //         }
    //     } catch (error) {
    //         console.error("Error sending reply", error);
    //         toast.error("Error sending reply");
    //     } finally {
    //         setLoading(false);
    //     }
    // }

    if (!complaint) return <div className="pc-container"><p>Loading...</p></div>;

    return (
        <div className="pc-container">
            <div className="pc-content">
                <div className="page-header">
                    <div className="page-block">
                        <div className="row align-items-center">
                            <div className="col-md-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/complaints">Complaints</Link>
                                    </li>
                                    <li className="breadcrumb-item" aria-current="page">
                                        Complaint Details
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-12">
                                <div className="page-header-title">
                                    <h2 className="mb-0">Complaint Details</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    {/* <div className="col-sm-12 text-center mb-3">
                                        <div className="user-upload wid-75">
                                            <img
                                                src={complaint.screenshotPath || avtar5}
                                                alt="screenshot"
                                                className="img-fluid"
                                            />
                                        </div>
                                    </div> */}

                                    {/* Complaint Info */}
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className="form-label">Complaint Type</label>
                                            <input type="text" className="form-control" value={complaint.type} disabled />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Subject</label>
                                            <input type="text" className="form-control" value={complaint.subject} disabled />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Description</label>
                                            <textarea className="form-control" value={complaint.description} disabled />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Admin Reply</label>
                                            <input type="text" className="form-control" value={complaint.reply} disabled />
                                        </div>
                                        <div className='form-group'>
                                            <label className="form-label">User Side Image</label>
                                            <img
                                                src={complaint.screenshotPath || avtar5}
                                                alt="screenshot"
                                                className="img-fluid"
                                            />
                                        </div>
                                        <div className='form-group'>
                                            <label className="form-label">Admin Side Image</label>
                                            <img
                                                src={complaint.adminReplyImage || avtar5}
                                                alt="screenshot"
                                                className="img-fluid"
                                            />
                                        </div>
                                    </div>

                                    {/* Complaint Status + User Info */}
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className="form-label">Status</label>
                                            <input type="text" className="form-control" value={complaint.status} disabled />
                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">Created At</label>
                                            <input type="text" className="form-control" value={new Date(complaint.createdAt).toLocaleString()} disabled />
                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">Created By (User)</label>
                                            <input type="text" className="form-control" value={complaint.user?.username || "-"} disabled />
                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">User Email</label>
                                            <input type="text" className="form-control" value={complaint.user?.email || "-"} disabled />
                                        </div>


                                        

                                    </div>
                                </div>

                                {/* Reply Section */}
                                <div className="mt-4">
                                    <h5>Admin Reply</h5>
                                    <textarea
                                        className="form-control mb-2"
                                        rows="4"
                                        placeholder="Type your reply here..."
                                        value={replyMessage}
                                        onChange={(e) => setReplyMessage(e.target.value)}
                                    />


                                     <div className="form-group mt-2">
                                    <label className="form-label">Upload Image (optional)</label>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        className="form-control"
                                        onChange={(e) => setReplyImage(e.target.files[0])}
                                    />
                                    </div>

                                    <button
                                        className="btn btn-primary"
                                        onClick={handleSendReply}
                                        disabled={loading}
                                    >
                                        {loading ? "Sending..." : "Send Reply"}
                                    </button>

                                    {/* Display previous replies if any */}
                                    {complaint.replies && complaint.replies.length > 0 && (
                                        <div className="mt-3">
                                            <h6>Previous Replies:</h6>
                                            <ul className="list-group">
                                                {complaint.replies.map((r) => (
                                                    <li key={r.id} className="list-group-item">
                                                        <strong>{r.adminName || "Admin"}:</strong> {r.reply}
                                                        <br />
                                                        <small className="text-muted">{new Date(r.createdAt).toLocaleString()}</small>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>


                               


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default View;
